module.exports = __webpack_public_path__ + "img/culture2.2f396f7e.jpg";